import { useEffect, useState } from "react";
import { CreditCard } from "lucide-react";
import { api, inr } from "../lib/api";

export default function BankOffers({ amount, compact, selected, onSelect }) {
  const [offers, setOffers] = useState([]);
  useEffect(() => { api.get("/bank-offers").then((r) => setOffers(r.data)); }, []);
  if (!offers.length) return null;
  const saving = (o) => {
    if (amount == null || amount < o.min_order) return null;
    const d = o.type === "percent" ? (amount * o.value) / 100 : o.value;
    return o.max_discount ? Math.min(d, o.max_discount) : d;
  };
  return (
    <div data-testid="bank-offers" className="space-y-2">
      <p className="text-xs uppercase tracking-wider text-slate-500 flex items-center gap-1"><CreditCard size={13} />{onSelect ? "Choose a bank offer (pay with that bank's card/UPI)" : "Bank offers"}</p>
      {offers.slice(0, compact ? 3 : 10).map((o) => {
        const s = saving(o);
        return (
          <div key={o.id} data-testid={`bank-offer-${o.id}`} role={onSelect ? "button" : undefined} onClick={onSelect ? () => onSelect(selected === o.id ? "" : o.id) : undefined}
            className={`flex items-start gap-3 rounded-xl border px-3 py-2.5 text-sm ${onSelect ? "cursor-pointer" : ""} ${selected === o.id ? "ring-2 ring-[#ff5500]" : ""}`} style={{ borderColor: `${o.color}55`, background: `${o.color}12` }}>
            {onSelect && <input type="radio" readOnly checked={selected === o.id} data-testid={`bank-offer-select-${o.id}`} className="mt-1 accent-[#ff5500]" />}
            <span className="mt-0.5 text-[10px] font-black uppercase px-1.5 py-0.5 rounded" style={{ background: o.color, color: "#000" }}>{o.bank}</span>
            <div className="flex-1 min-w-0">
              <p className="font-semibold leading-snug">{o.title}</p>
              <p className="text-[11px] text-slate-400">{o.payment_mode}{o.min_order ? ` · Min order ${inr(o.min_order)}` : ""}{o.max_discount ? ` · Up to ${inr(o.max_discount)}` : ""}</p>
            </div>
            {s != null && <span className="text-xs font-bold text-emerald-400 whitespace-nowrap">Save {inr(s)}</span>}
          </div>
        );
      })}
    </div>
  );
}
